var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layout-iOS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9.0.3-Resultados---Empty-State",
    transform: "translate(-164.000000, -148.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "--Indicar-um-espa\\xE7o",
    transform: "translate(15.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "very-sad",
    transform: "translate(149.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#EE3310",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5172841,21.5172414 C45.5178138,30.9054472 40.0439499,39.431917 31.507637,43.3395722 C22.9713241,47.2472274 12.940252,45.818429 5.83448276,39.6827586 C-2.38290343,30.1659334 -1.86168349,15.9200711 7.02919381,7.02919381 C15.9200711,-1.86168349 30.1659334,-2.38290343 39.6827586,5.83448276 C43.4559248,10.1869779 45.5281333,15.7569568 45.5172841,21.5172414 Z",
    id: "Shape",
    fill: "#F16247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2068966,22.3448276 L23.1724138,22.3448276 C26.3718564,22.3448276 28.9655172,24.9384884 28.9655172,28.137931 L28.9655172,31.4482759 C28.9655172,31.9053391 28.5949942,32.2758621 28.137931,32.2758621 L13.2413793,32.2758621 C12.7843161,32.2758621 12.4137931,31.9053391 12.4137931,31.4482759 L12.4137931,28.137931 C12.4137931,24.9384884 15.0074539,22.3448276 18.2068966,22.3448276 Z",
    id: "Shape",
    fill: "#802D40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9655172,28.137931 L28.9655172,31.4482759 C28.9641991,31.9047919 28.5944471,32.2745439 28.137931,32.2758621 L18.2068966,32.2758621 C18.1055485,31.6130768 18.0888631,30.9400968 18.1572414,30.2731034 L18.1572414,30.2565517 C18.1792454,29.0461499 18.8236163,27.9325769 19.862069,27.3103448 C22.7668966,25.862069 27.5834483,26.3172414 28.7172414,26.4496552 C28.8807146,26.9975556 28.9643335,27.5661645 28.9655172,28.137931 L28.9655172,28.137931 Z",
    id: "Shape",
    fill: "#FF5364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9655172,28.137931 L28.9655172,29.7931034 C28.9641991,30.2496195 28.5944471,30.6193715 28.137931,30.6206897 L18.2068966,30.6206897 C18.2068966,30.6206897 18.182069,30.4882759 18.1572414,30.2731034 L18.1572414,30.2565517 C18.1792454,29.0461499 18.8236163,27.9325769 19.862069,27.3103448 C22.7668966,25.862069 27.5834483,26.3172414 28.7172414,26.4496552 C28.8807146,26.9975556 28.9643335,27.5661645 28.9655172,28.137931 L28.9655172,28.137931 Z",
    id: "Shape",
    fill: "#FB7B76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.184,26.9775724 C41.6964933,29.163737 40.3725068,31.3598375 38.1999448,31.9272342 C36.0273827,32.4946309 33.7986298,31.2263809 33.1766897,29.0688 C32.6136828,26.9131034 35.4811862,21.5172414 35.4811862,21.5172414 C35.4811862,21.5172414 40.6209103,24.8216276 41.184,26.9775724 L41.184,26.9775724 Z",
    id: "Shape",
    fill: "#84B5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9613241,25.806869 C40.3635251,27.5241578 39.3234116,29.2490071 37.6168941,29.694703 C35.9103766,30.1403988 34.1596617,29.1444377 33.6707586,27.4497931 C33.2284138,25.7561379 35.4811862,21.5172414 35.4811862,21.5172414 C35.4811862,21.5172414 39.5190621,24.1132138 39.9613241,25.806869 L39.9613241,25.806869 Z",
    id: "Shape",
    fill: "#9FC9D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.195310345,26.9775724 C-0.346786105,29.1681841 0.989098626,31.3836062 3.17950345,31.9265379 C5.35584337,32.524255 7.60472898,31.2448355 8.20295172,29.0686345 C8.76562759,26.9131034 5.89812414,21.5172414 5.89812414,21.5172414 C5.89812414,21.5172414 0.7584,24.8216276 0.195310345,26.9775724 Z",
    id: "Shape",
    fill: "#84B5CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.41798621,25.806869 C0.992028712,27.5278884 2.04150814,29.2684505 3.76237241,29.6950345 C5.47203949,30.1643641 7.23855516,29.1592769 7.70855172,27.4497931 C8.15089655,25.7561379 5.89812414,21.5172414 5.89812414,21.5172414 C5.89812414,21.5172414 1.86024828,24.1132138 1.41798621,25.806869 Z",
    id: "Shape",
    fill: "#9FC9D3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12.4137931,
    cy: 16.5517241,
    r: 3.31034483
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9655172,
    cy: 16.5517241,
    r: 3.31034483
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2C3E50",
    cx: 11.5862069,
    cy: 16.5517241,
    r: 1.65517241
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2C3E50",
    cx: 28.137931,
    cy: 16.5517241,
    r: 1.65517241
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12.4137931,
    cy: 14.8965517,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 28.9655172,
    cy: 14.8965517,
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.354526, 10.664871)",
    fill: "#2E2D7B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.922163793,5.88685409 C0.562142268,5.88729852 0.243135757,5.6549388 0.133132179,5.3121343 C0.0231286014,4.96932989 0.147367837,4.59473574 0.440425862,4.38561207 L6.23352931,0.247681034 C6.6055788,-0.0179183586 7.12249535,0.0683763724 7.38809483,0.440425862 C7.65369422,0.812475352 7.56739949,1.3293919 7.19535,1.59499138 L1.40224655,5.73292241 C1.26222832,5.8331239 1.09434228,5.886954 0.922163793,5.88685409 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7480948,5.88685419 C25.5759446,5.8869367 25.4080901,5.83310752 25.2680948,5.73292241 L19.4749914,1.59499138 C19.1029419,1.3293919 19.0166472,0.812475352 19.2822466,0.440425862 C19.547846,0.0683763724 20.0647626,-0.0179183586 20.4368121,0.247681034 L26.2299155,4.38561207 C26.5229861,4.59474451 26.6472221,4.96936026 26.5371967,5.31217386 C26.4271714,5.65498738 26.1081317,5.88733461 25.7480948,5.88685419 Z",
    id: "Shape"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.2ea81ca2d1391ac82554873b3cddf61a.svg";
export { ForwardRef as ReactComponent };